module.exports = __webpack_public_path__ + "static/media/Group 679.350736ad.svg";